export function RatingStars({
  value,
  count,
  dark = false,
}: {
  value: number;
  count?: number;
  dark?: boolean;
}) {
  return (
    <div className="flex items-center gap-1.5">
      <div className="flex items-center gap-0.5" aria-label={`${value} out of 5 stars`}>
        {[1, 2, 3, 4, 5].map((i) => (
          <svg key={i} width="13" height="13" viewBox="0 0 20 20" className="shrink-0">
            <path
              d="M10 1.5l2.59 5.25 5.79.84-4.19 4.08.99 5.77L10 14.77l-5.18 2.67.99-5.77L1.62 7.6l5.79-.84L10 1.5z"
              fill={i <= Math.round(value) ? '#c9862c' : 'none'}
              stroke={i <= Math.round(value) ? '#c9862c' : dark ? 'rgba(246,243,237,0.35)' : '#d9d4c8'}
              strokeWidth="1"
            />
          </svg>
        ))}
      </div>
      {count !== undefined && (
        <span className={`text-xs ${dark ? 'text-cream/60' : 'text-stone'}`}>
          {value.toFixed(1)} ({count})
        </span>
      )}
    </div>
  );
}
